import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { SeoService } from "src/app/services/seo.service";

const httpOptions = {
  headers: new HttpHeaders({ "Content-Type": "application/json" }),
};

interface WebinarRequest {
  WebinarDate: string;
  Email: string;
  Salutation: string;
  FirstName: string;
  LastName: string;
  Phone: string;
  CompanyName: string;
  Devision: string;
  Function: string;
  RegistrationMethod: string;
}

@Component({
  selector: "v2m-webinar",
  templateUrl: "./webinar.component.html",
  styleUrls: ["./webinar.component.scss"],
})
export class WebinarComponent implements OnInit {
  apiUrl = "https://api.video2manual.de/webinar/register";
  //apiUrl = "https://localhost:44394/webinar/register";
  date = 1;
  webinarDate = new Date(2024, 2, 19, 10, 0, 0);
  salutation = "";
  lastname = "";
  firstname = "";
  email = "";
  phone = "";
  company = "";
  function = "";
  devision = "";
  privacy = false;
  isSending = false;
  isSended = false;

  constructor(private http: HttpClient, private seo: SeoService) {}

  ngOnInit() {
    this.seo.updateTitle("video2manual - Webinar");
    this.seo.updateKeywords("Webinar,Training");
  }

  send() {
    if (this.date == 1) this.webinarDate = new Date(2024, 2, 19, 10, 0, 0);
    else if (this.date == 2) this.webinarDate = new Date(2024, 3, 23, 10, 0, 0);
    const request: WebinarRequest = {
      WebinarDate: this.webinarDate.toJSON(),
      Email: this.email,
      Salutation: this.salutation ?? "",
      FirstName: this.firstname ?? "",
      LastName: this.lastname,
      Phone: this.phone ?? "",
      CompanyName: this.company ?? "",
      Devision: this.devision ?? "",
      Function: this.function ?? "",
      RegistrationMethod: "Website",
    };

    this.isSending = true;

    this.http.post(this.apiUrl, request, httpOptions).subscribe((_) => {
      this.isSending = false;
      this.isSended = true;
    });
  }
}
